import db from '../../../../services/firebase'
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  onSnapshot,
  runTransaction,
} from 'firebase/firestore'

class PolicyDataService {
  // Add a new policy
  addPolicy = async (tenantId, newPolicy) => {
    const tenantRef = doc(db, 'tenants', tenantId)
    const policyRef = collection(tenantRef, 'policies')
    const policyWithTimestamps = {
      ...newPolicy,
      created_at: serverTimestamp(),
      updated_at: serverTimestamp(),
    }
    return addDoc(policyRef, policyWithTimestamps)
  }

  // Update a policy
  updatePolicy = async (tenantId, id, updatePolicy) => {
    const policyDoc = doc(db, 'tenants', tenantId, 'policies', id)
    const policyWithTimestamp = {
      ...updatePolicy,
      updated_at: serverTimestamp(),
    }
    return updateDoc(policyDoc, policyWithTimestamp)
  }

  // Delete a policy
  deletePolicy = async (tenantId, id) => {
    const policyDoc = doc(db, 'tenants', tenantId, 'policies', id)
    return deleteDoc(policyDoc)
  }

  // Get all policies (real-time)
  listenPolicies = (tenantId, callback) => {
    const tenantRef = doc(db, 'tenants', tenantId)
    const policyRef = collection(tenantRef, 'policies')
    return onSnapshot(policyRef, callback)
  }

  // Get all policies (one-time)
  getAllPolicies = async (tenantId) => {
    const tenantRef = doc(db, 'tenants', tenantId)
    const policyRef = collection(tenantRef, 'policies')
    const snapshot = await getDocs(policyRef)
    return snapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))
  }

  // Get a single policy by id
  getPolicyById = async (tenantId, id) => {
    const policyDoc = doc(db, 'tenants', tenantId, 'policies', id)
    const snapshot = await getDoc(policyDoc)
    if (snapshot.exists()) {
      return {...snapshot.data(), id: snapshot.id}
    }
    return null
  }

  // Assign owner to one or more policies
  assignOwner = async (tenantId, policyIds, owner) => {
    const tenantRef = doc(db, 'tenants', tenantId)
    const updatePromises = policyIds.map((policyId) => {
      const policyDocRef = doc(tenantRef, 'policies', policyId)
      return updateDoc(policyDocRef, {owner, updated_at: serverTimestamp()})
    })
    return Promise.all(updatePromises)
  }

  // Activity logging
  logActivity = async (tenantId, user, message, action, target) => {
    const tenantRef = doc(db, 'tenants', tenantId)
    const activitiesRef = collection(tenantRef, 'activities')
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() + 1
    const day = currentDate.getDate()
    const todaysDate = month + '/' + day + '/' + year
    await addDoc(activitiesRef, {
      message,
      timestamp: serverTimestamp(),
      tenantId,
      uid: user?.uid,
      action,
      target,
      email: user?.email,
      username: user?.userName,
      date: todaysDate,
    })
  }

  // Update policy with transaction (for status/owner changes)
  updatePolicyTransaction = async (tenantId, id, updateData) => {
    const policyRef = doc(db, 'tenants', tenantId, 'policies', id)
    await runTransaction(db, async (transaction) => {
      const policyDoc = await transaction.get(policyRef)
      if (!policyDoc.exists()) {
        throw new Error('Document does not exist!')
      }
      transaction.update(policyRef, {
        ...updateData,
        updated_at: serverTimestamp(),
      })
    })
  }
}

const policyDataService = new PolicyDataService()
export default policyDataService
